import { render, staticRenderFns } from "./TicketFormNew.vue?vue&type=template&id=adba6ccc&scoped=true&"
import script from "./TicketFormNew.vue?vue&type=script&lang=js&"
export * from "./TicketFormNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adba6ccc",
  null
  
)

export default component.exports